import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {CheckinsService} from '../../core/checkins/checkins.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  @Output() close = new EventEmitter();

  dateForm: FormGroup;

  exportError: string;
  exportSuccess: string;

  bsConfig = {
    containerClass: 'theme-blue'
  };

  constructor(private fb: FormBuilder, private checkinsService: CheckinsService) {}

  ngOnInit() {
    this.dateForm = this.fb.group({
      from: [moment().subtract(1, 'months').toDate(), Validators.required],
      to: [new Date(), Validators.required]
    });
  }

  exportCheckins(exportData) {
    this.exportSuccess = '';
    this.exportError = '';
    this.checkinsService.export(exportData)
      .subscribe((data: any) => {
        this.exportSuccess = 'File download started';
        window.location.assign(`/api/download/${data.filename}`);
      }, err => {
        this.exportError = err.error.message;
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.component.ts